// ─── マスターの会話エンジン（キーワード応答型・サーバー不要）───
// 返り値: { text, productIds?: string[], quickReplies?: string[] }

const DEFAULT_REPLIES = ['おすすめは？', '豆の違いを教えて', 'おいしい淹れ方', 'お店のこと'];

export const GREETING = {
  text: 'いらっしゃい。GURI COFFEEのマスターや。\n豆のこと、淹れ方のこと、なんでも聞いてくまっし。',
  quickReplies: DEFAULT_REPLIES,
};

// 意図ごとのキーワードと応答（上から順に判定・先勝ち）
const INTENTS = [
  {
    id: 'fruity',
    keywords: ['フルーティ', 'ふるーてぃ', '酸味', '華やか', 'ワイン', 'ハニー', '甘み', '甘い'],
    reply: {
      text: 'それなら「グアテマラハニー」やね。\nハニープロセスならではの甘みとフルーティーな香り、後味はワインみたいな余韻が残るんや。うちの看板豆やわ。',
      productIds: ['guatemala-honey'],
      quickReplies: ['深煎りも見たい', '定期便ってなに？', 'おいしい淹れ方'],
    },
  },
  {
    id: 'dark',
    keywords: ['深煎り', '苦', 'ビター', 'しっかり', 'コク', 'カカオ', 'shb', 'ミルク'],
    reply: {
      text: '深めが好きなら「グアテマラSHB」や。\nカカオみたいな甘みと、深煎りらしいしっかりした味わい。ミルクにも負けんから、カフェオレにもええよ。',
      productIds: ['guatemala-shb'],
      quickReplies: ['フルーティーな方も見たい', '定期便ってなに？', 'おいしい淹れ方'],
    },
  },
  {
    id: 'subscription',
    keywords: ['定期', '毎月', 'サブスク', '切らし', 'お得'],
    reply: {
      text: '毎月飲むなら定期便が一番お得やよ。\n300gが毎月届いて10%OFF、送料も無料や。豆を切らす心配がなくなるのが、なにより余白時間にええんやわ。',
      productIds: ['subscription'],
      quickReplies: ['おすすめは？', '豆の違いを教えて'],
    },
  },
  {
    id: 'recommend',
    keywords: ['おすすめ', 'オススメ', 'お勧め', '選', 'どれ', '迷', '初めて', 'はじめて'],
    reply: {
      text: 'ほんなら好みを聞かせてくれんか。\nフルーティーで華やかなのが好きか、深煎りのしっかりした味が好きか。毎月飲むなら定期便っちゅう手もあるよ。',
      quickReplies: ['フルーティーが好き', '深煎りでしっかり', '毎月飲みたい'],
    },
  },
  {
    id: 'difference',
    keywords: ['違い', '比べ', 'どっち', '比較'],
    reply: {
      text: '同じグアテマラでも性格は全然違うんや。\n「ハニー」は甘みと香りの華やかさ、ワインみたいな後味。「SHB」はカカオっぽい甘みで、どっしり深煎り。\n朝にすっきり飲むならハニー、じっくり午後の一杯ならSHBかな。',
      productIds: ['guatemala-honey', 'guatemala-shb'],
      quickReplies: ['フルーティーが好き', '深煎りでしっかり', 'おいしい淹れ方'],
    },
  },
  {
    id: 'brewing',
    keywords: ['淹れ', 'いれ方', '入れ方', '抽出', 'ドリップ', 'おいしく', '美味しく', 'コツ'],
    reply: {
      text: '家で淹れるなら「4:6メソッド」がおすすめや。\nお湯を5回に分けて注ぐだけ。最初の2投（4割）で味の濃さ、残りの3投（6割）で強さが決まる。\n豆は中挽き、お湯は92℃くらい。うちで作った無料のタイマーアプリ「Pour.」を使うと簡単やよ → pour-timer-app.netlify.app',
      quickReplies: ['おすすめの豆は？', 'お店のこと'],
    },
  },
  {
    id: 'gift',
    keywords: ['ギフト', '贈り物', 'プレゼント', '法人', 'お歳暮', 'お中元', '手土産'],
    reply: {
      text: '贈り物にコーヒーはええ選択やと思うわ。\n大切な人の「余白時間」を贈るっちゅうことやからね。法人ギフトの相談ものっとるから、BASEショップのメッセージから気軽に声かけてくまっし。',
      productIds: ['guatemala-honey'],
      quickReplies: ['おすすめは？', '定期便ってなに？'],
    },
  },
  {
    id: 'brand',
    keywords: ['お店', '店', 'ブランド', 'コンセプト', '余白', '那谷', 'あなた', 'マスター', '誰', 'どんな人', 'guri'],
    reply: {
      text: 'GURI COFFEEは石川県の加賀・小松エリアで焙煎しとる、実店舗を持たんコーヒー屋や。\n那谷寺の深い静けさが世界観の核でね。急ぎすぎる時代に、立ち止まる場所を——コーヒーで「人生の余白時間」を守りたいんやわ。\n壁の額縁に、その物語を飾っとるから見ていってくまっし。',
      quickReplies: ['おすすめは？', 'おいしい淹れ方'],
    },
  },
  {
    id: 'greeting',
    keywords: ['こんにちは', 'こんばんは', 'おはよう', 'はじめまして', 'やあ', 'ハロー', 'hello', 'hi'],
    reply: {
      text: 'はい、いらっしゃい。\nゆっくりしていってくまっし。何か気になることあるけ？',
      quickReplies: DEFAULT_REPLIES,
    },
  },
  {
    id: 'thanks',
    keywords: ['ありがと', 'さんきゅ', '助かった', 'thanks'],
    reply: {
      text: 'なんも、なんも。\nまたいつでも寄ってくまっし。あんたの余白時間に、うちの一杯が合うとうれしいわ。',
      quickReplies: ['おすすめは？', 'お店のこと'],
    },
  },
  {
    id: 'bye',
    keywords: ['さよなら', 'バイバイ', 'また来る', 'またね', 'じゃあね', 'bye'],
    reply: {
      text: 'おおきに。気をつけて帰るまっし。\nまた豆が切れたころに、ふらっと寄ってくれたらええわ。',
      quickReplies: [],
    },
  },
];

const FALLBACK = {
  text: 'すまんね、ちょっとうまく聞き取れんかったわ。\n豆選びでも淹れ方でも、下のボタンからでも聞いてくれるとありがたいわ。',
  quickReplies: DEFAULT_REPLIES,
};

/**
 * ユーザーの発言に対するマスターの返答を返す。
 */
export function masterReply(input) {
  const text = (input || '').toLowerCase().trim();
  if (!text) return FALLBACK;

  for (const intent of INTENTS) {
    if (intent.keywords.some((k) => text.includes(k.toLowerCase()))) {
      return intent.reply;
    }
  }
  return FALLBACK;
}
